import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import * as ed25519 from "@stablelib/ed25519";
import { randomBytes } from "@stablelib/random";
import { fromMiliseconds } from "@walletconnect/time";
import { JWT_IRIDIUM_ALG, JWT_IRIDIUM_TYP, KEY_PAIR_SEED_LENGTH } from "./constants";
import { decodeIss, decodeJWT, encodeData, encodeIss, encodeJWT } from "./utils";
export function generateKeyPair() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : randomBytes(KEY_PAIR_SEED_LENGTH);
  return ed25519.generateKeyPairFromSeed(seed);
}
export function signJWT(_x, _x2, _x3, _x4) {
  return _signJWT.apply(this, arguments);
}
function _signJWT() {
  _signJWT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sub, aud, ttl, keyPair) {
    var iat,
      header,
      iss,
      exp,
      payload,
      data,
      signature,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          iat = _args.length > 4 && _args[4] !== undefined ? _args[4] : fromMiliseconds(Date.now());
          header = {
            alg: JWT_IRIDIUM_ALG,
            typ: JWT_IRIDIUM_TYP
          };
          iss = encodeIss(keyPair.publicKey);
          exp = iat + ttl;
          payload = {
            iss: iss,
            sub: sub,
            aud: aud,
            iat: iat,
            exp: exp
          };
          data = encodeData({
            header: header,
            payload: payload
          });
          signature = ed25519.sign(keyPair.secretKey, data);
          return _context.abrupt("return", encodeJWT({
            header: header,
            payload: payload,
            signature: signature
          }));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _signJWT.apply(this, arguments);
}
export function verifyJWT(_x5) {
  return _verifyJWT.apply(this, arguments);
}
function _verifyJWT() {
  _verifyJWT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jwt) {
    var _decodeJWT, header, payload, data, signature, publicKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _decodeJWT = decodeJWT(jwt), header = _decodeJWT.header, payload = _decodeJWT.payload, data = _decodeJWT.data, signature = _decodeJWT.signature;
          if (!(header.alg !== JWT_IRIDIUM_ALG || header.typ !== JWT_IRIDIUM_TYP)) {
            _context2.next = 3;
            break;
          }
          throw new Error("JWT must use EdDSA algorithm");
        case 3:
          publicKey = decodeIss(payload.iss);
          return _context2.abrupt("return", ed25519.verify(publicKey, data, signature));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _verifyJWT.apply(this, arguments);
}